import client from '@/api/client.js';
import store from "@/store";
//import i18n from '@/plugins/i18n.js'
export default {
    methods: {
        async GetContractTypeMap() {
            var meta = { clientApiMethod: 'GetContractTypeMap' };
            var response = await client().get(store.state.apiRouteRoot + 'Contract/TypeMap', { meta: meta })
            return response?.data;
        },
        async getContractListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getContractListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Contract/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getContractById(id) {
            var meta = { clientApiMethod: 'getAssetType', input: { id: id } }
            var response = await client().get(store.state.apiRouteRoot + "Contract/" + id, { meta: meta })
            return response?.data;
        },
    }
}